import { useQuery } from "@tanstack/react-query";

import { MatchMaker as MatchMakerFlow } from "@libs/creditkit";

import { scoreQueries } from "@hub/apis/score/scoreQueries";
import { LoaderCircular } from "@hub/components/LoaderCircular";
import { useAuthentication } from "@libs/acp/contexts";

export function MatchMaker() {
	const { data: negativeDebts } = useQuery({
		...scoreQueries.negative(),
	});
	const {
		customer: user,
		tokens: { accessToken },
	} = useAuthentication();

	if (!accessToken || !user) return <LoaderCircular fullPage />;
	return (
		<MatchMakerFlow
			user={user}
			token={accessToken}
			negativeDebts={negativeDebts}
		/>
	);
}
